import React, { Component, useEffect, useState } from 'react'

import CommonTable2 from '../../common/CommonTable2'
import Modal from '../../common/CommonModal'
import { CallApiGet, updateTeam, CallApi } from '../../helpers/CallApiGet'
import { useAuth } from '../authentication/auth'
import axios from 'axios'
import man from '../../assets/images/man-group.jpg'
import {
  Dimmer,
  Loader,
  Image,
  Segment,
  Confirm,
  Item
} from 'semantic-ui-react'
import { CommonNotify } from '../../common/CommonNotify'

//redux
import { connect } from 'react-redux'
import { getTeams } from '../../actions/settings'
import { Grid, Typography } from '@mui/material'

const apiToken = localStorage.getItem('access_token')

class TeamSettings extends Component {
  state = {
    isLoading: true,
    tableLoading: false,
    dataTable: {
      type: '4',
      header: [
        {
          headerTitle: 'ID'
        },
        {
          headerTitle: 'Name'
        },
        {
          headerTitle: 'Members'
        },
        {
          headerTitle: 'Action'
        }
      ],
      tableContentData: []
    },
    open: false,
    dataId: null,
    isError: '',
    dataName: null
  }

  componentDidUpdate(prevProps) {
    let table = this.state.dataTable
    if (this.props.teams !== prevProps.teams) {
      table.tableContentData = this.props.teams.data
      this.setState({
        dataTable: table,
        isLoading: false,
        tableLoading: false
      })
    }
  }

  componentDidMount() {
    this.loadTeam()
  }

  loadTeam = () => {
    let table = this.state.dataTable
    if (this.props.teams) {
      table.tableContentData = this.props.teams.data
      this.setState({
        dataTable: table,
        isLoading: false,
        tableLoading: false
      })
    } else {
      this.setState({
        isLoading: true,
        tableLoading: true
      })
      this.props.getTeams()
    }
    /* const data = []
    
    const url = `${process.env.REACT_APP_BASE_APP_URL}/api/v1/team/teams?limit=20000&offset=0`

    let table = { ...this.state.dataTable }

    axios
      .get(url)
      .then(res => {
        if (res.data.data) {
          table.tableContentData = res.data.data
          this.setState({
            dataTable: table,
            isLoading: false,
            tableLoading: false
          })
        }
      })
      .catch(err => {      
        this.setState({
          tableLoading: false,
          isLoading: false,
          tableLoading: false
        })
      }) */
  }

  handleData = data => {




    if (data.columnOne !== null) {
      const { dataTable } = this.state
      const tableContentData = dataTable.tableContentData

      const apiData = {
        name: data.columnOne,
        type: data.columnTwo
      }

      CallApi(apiData)
        .then(res => {

          this.loadTeam()



        })
        .catch(error => {

          if (error.response) {
            // Request made and server responded


            if (error.response.data.errors?.length) {
              CommonNotify(error.response.data.errors[0])
            }




          } else if (error.request) {
            // The request was made but no response was received

          } else {
            // Something happened in setting up the request that triggered an Error

          }

          //CommonNotify(err.message)



        })
    } else {
      CommonNotify('Name field is required', 'error')
    }
  }

  handleUpdatedInfo = data => {
    updateTeam(data).then(res => {
      this.loadTeam()
    })
  }

  openConfirm = (id, name) => {
    this.setState({ open: true, dataId: id, dataName: name })
  }

  close = () => this.setState({ open: false })

  deleteTeam = () => {
    this.setState({ tableLoading: true })



    this.setState({ open: false })
    const url = `${process.env.REACT_APP_BASE_APP_URL}/api/v1/team/delete-team/${this.state.dataId}`
    axios
      .delete(url)
      .then(res => {
        if ((res.data.message[0] = 'Successfully')) {
          this.loadTeam()
          CommonNotify('Team deleted successfully', 'success')
        }
      })

      .catch(error => {
        CommonNotify(error.response.data.errors[0], 'error')
        this.setState({
          tableLoading: false
        })
      })
  }

  render() {
    const { dataTable } = this.state
    const len = dataTable.tableContentData
    const infoData = [
      {
        img: man,
        text: 'Organize users by department, location, job function or schedulling needs.'
      },
      {
        img: man,
        text: 'Download reports by group to track and optimize your limecall usage.'
      },
      {
        img: man,
        text: 'Assign group admins control of group management.'
      },
    ]
    return (
      <>
        <Dimmer active={this.state.isLoading} style={{ position: 'fixed' }}>
          <Loader />
        </Dimmer>
        <div className="teamsetting-wrapper team_settings">
          <div className="create-button-holder">
            <p className="create-button-title"> Total Teams {len?.length}</p>{' '}
            <Modal handleData={this.handleData} />{' '}
          </div>{' '}
          <CommonTable2
            loadTeam={this.loadTeam}
            handleUpdatedInfo={this.handleUpdatedInfo}
            dataTable={this.state.dataTable}
            deleteTeam={this.openConfirm}
            tableLoading={this.state.tableLoading}
            type={4}
          />{' '}
          <Confirm
            className="confirmBox-wrapper"
            open={this.state.open}
            header="Delete Team!"
            content={`Do you want to delete Team -  ${this.state.dataName} ?`}
            onCancel={this.close}
            onConfirm={this.deleteTeam}
          />
        </div>
        <div>
          <Grid mt={12} container spacing={3} className='info-teams' >
            {infoData?.map((obj, index) =>
              <Grid item md={4} >
                <img height={100} width={100} src={obj?.img} alt={index} style={{ margin: 'auto' }} />
                <Typography mt={1}>{obj?.text}</Typography>

              </Grid>
            )}
          </Grid>

        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  teams: state.settings.teams,
});

export default connect(
  mapStateToProps,
  { getTeams }
)(TeamSettings)
